var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "fade" } },
    [
      _vm.summary
        ? _c(
            "base-card",
            { attrs: { title: _vm.$t("menu.appointment-info") } },
            [
              _c("labeled-text", {
                attrs: {
                  label: _vm.$t("appointment-info.date"),
                  text: _vm._f("beautifyDate")(_vm.summary.scheduledDateTime)
                }
              }),
              _vm._v(" "),
              _c("labeled-text", {
                attrs: {
                  label: _vm.$t("appointment-info.disease"),
                  text: _vm.$i18nHelpers.normalize(_vm.summary.disease)
                }
              }),
              _vm._v(" "),
              _c("labeled-text", {
                attrs: {
                  label: _vm.$t("appointment-info.reason"),
                  text: _vm.summary.reason
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-661993b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-661993b3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/AppointmentInfo.vue
// module id = 3460
// module chunks = 28